<main class="info-container" role="main" aria-labelledby="page-title">
    <div class="info-area" role="region" aria-label="Manager Request Confirmation">
        <img
            src="/assets/images/placeholder-img.svg"
            width="394"
            height="300"
            class="placeholder-image"
            alt=""
            role="presentation"
        />
        <h1 class="title" id="page-title">We'll Reach Out to You!</h1>
        <h2>Thank you!</h2>
        <p class="text-info">
            Just sit back and relax. Your local Merry Maids will contact you shortly to finalize
            your request! Looking forward to helping you keep your space spotless!
        </p>
    </div>
    <a [href]="localSiteUrl" class="link-back">Back to main site</a>
</main>
